import type { QTableColumn } from 'quasar';
import { formatDate } from 'src/utils/formatDate';
type CommonAttributes = {
  id: string;
  name: string;
  updated_at: string;
  group_or_resource_type: {
    id: string;
    name: string;
  };
};
type GroupTypePathItems = {
  path_items: PathItem[];
};
type GroupModelAttirbutes = {
  type: 'group';
} & GroupTypePathItems &
  CommonAttributes;
type ResourceModelAttirbutes = {
  type: 'resource';
  paths: GroupTypePathItems[];
} & CommonAttributes;
export type GroupResourceModelAttributes =
  | GroupModelAttirbutes
  | ResourceModelAttirbutes;
type PathItem = {
  id: string;
  name: string;
};
export class GroupResourceModel {
  id: string;
  name: string;
  type: string;
  group_or_resource_type: {
    id: string;
    name: string;
  };
  path_items?: PathItem[];
  paths?: GroupTypePathItems[];
  updated_at: string;

  constructor(input?: GroupResourceModelAttributes) {
    this.id = input ? input.id : '';
    this.name = input ? input.name : '';
    this.type = input ? input.type : '';
    this.group_or_resource_type = input
      ? input.group_or_resource_type
      : { id: '', name: '' };
    if (input && input.type == 'group') {
      this.path_items = input ? input.path_items : [];
    }
    this.updated_at = input ? formatDate(input.updated_at) : '';
  }

  getId(): string {
    return this.id;
  }
}
export type GroupResourceCollection = GroupResourceModel[];
export const GroupResourceTableColumns: QTableColumn[] = [
  {
    name: 'id',
    label: 'ID',
    align: 'left',
    field: 'id',
    sortable: true,
  },
  {
    name: 'name',
    label: '名前',
    align: 'left',
    field: 'name',
    sortable: true,
  },
  {
    name: 'type',
    label: '種類',
    align: 'left',
    field: 'type',
    sortable: true,
  },
  {
    name: 'group_or_resource_type',
    label: '各タイプ',
    align: 'left',
    field: 'group_or_resource_type',
    sortable: true,
    format: (val) => val.name,
  },
  {
    name: 'updated_at',
    label: '更新日',
    align: 'left',
    field: 'updated_at',
    sortable: true,
  },
];
